import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountryDirective } from './directives/country.directive';
import { HasScopeDirective } from './directives/has-scope.directive';
import { SkeletonDirective } from '@app/shared/modules/directive/directives/skeleton.directive';
import { StatusDirective } from '@app/shared/modules/directive/directives/status.directive';
import { OrderResetDirective } from '@app/shared/modules/directive/directives/order-reset.directive';
import { SliderColorDirective } from '@app/shared/modules/directive/directives/SliderColor.directive';

const directives = [CountryDirective, HasScopeDirective, SkeletonDirective, StatusDirective, OrderResetDirective, SliderColorDirective];

@NgModule({
  declarations: [...directives],
  imports: [CommonModule],
  exports: [...directives],
})
export class DirectiveModule {}
